import { useMutation } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { ContestType } from 'src/types/domain.types';
import { toast } from 'react-toastify';
import { useGetContestQuery } from './getContest';

const updateContest = (contest: ContestType) =>
  api.put(`/contests/${contest.contest_id}`, contest);

export const useUpdateContestMutation = (contestId: number) => {
  const { refetch } = useGetContestQuery(contestId);

  return useMutation({
    mutationKey: ['update-contest', contestId],
    mutationFn: updateContest,
    onSuccess: () => {
      toast.success('Contest updated successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
